import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useRefetchStaleQueriesOnNavigate = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }

    queryClient.refetchQueries({
      stale: true,
    });
  }, [location, queryClient]);
};
